import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tooltip", "kpiValue"]

  connect() {
    // Controller verbunden
  }

  show(event) {
    event.preventDefault()
    
    // Zeige Tooltip
    this.tooltipTargets.forEach(tooltip => {
      // Positioniere das Tooltip relativ zum Element
      const rect = this.element.getBoundingClientRect()
      const tooltipRect = tooltip.getBoundingClientRect()
      
      // Positioniere oberhalb des Elements, zentriert
      tooltip.style.left = `${rect.left + (rect.width / 2) - (tooltipRect.width / 2)}px`
      tooltip.style.top = `${rect.top - tooltipRect.height - 10}px`
      
      tooltip.classList.remove('opacity-0', 'invisible')
      tooltip.classList.add('opacity-100')
    })
    
    // Ändere Kennzahl-Farbe zu grau (Hover-Effekt)
    this.kpiValueTargets.forEach(kpiValue => {
      kpiValue.classList.remove('text-gray-900')
      kpiValue.classList.add('text-gray-500')
    })
  }

  hide(event) {
    event.preventDefault()
    
    // Verstecke Tooltip
    this.tooltipTargets.forEach(tooltip => {
      tooltip.classList.add('opacity-0', 'invisible')
      tooltip.classList.remove('opacity-100')
    })
    
    // Stelle ursprüngliche Kennzahl-Farbe wieder her
    this.kpiValueTargets.forEach(kpiValue => {
      kpiValue.classList.remove('text-gray-500')
      kpiValue.classList.add('text-gray-900')
    })
  }

  toggle(event) {
    event.preventDefault()
    this.tooltipTargets.forEach(tooltip => {
      if (tooltip.classList.contains('opacity-0')) {
        this.show(event)
      } else {
        this.hide(event)
      }
    })
  }
}
